<template>
  <v-hover>
    <div
      class="p-reviewButtonBlock"
      :class="{
        'p-reviewButtonBlock__selected': selected() && isCommentStatus(),
      }"
      @mouseover="displayAddItemCommentBtn"
      @mouseleave="hideAddItemCommentBtn"
    >
      <div
        v-if="itemExist()"
        v-show="displayHoverItemFlag || noticedCommentFlag"
        class="p-reviewButtonBlock__reviewBlock p-reviewItemBlock__right"
      >
        <to-review-status-button
          :item="item"
          @on-display="noticedCommentFlag = $event"
        />
      </div>
      <div class="p-reviewItemBlock">
        <slot></slot>
      </div>
    </div>
  </v-hover>
</template>
<script>
import ToReviewStatusButton from '../ToReviewStatusButton'
import { mapState } from 'vuex'

export default {
  name: 'WithReviewButtonBlock',
  components: {
    ToReviewStatusButton
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
      displayHoverItemFlag: false,
      noticedCommentFlag: false
    }
  },
  computed: {
    ...mapState({
      editingItemIndex: (state) => state.PostEditor.editingItemIndex,
      toolBarStatus: (state) => state.PostEditor.toolBarStatus,
      selectedCommentItem: (state) => state.PostEditor.selectedCommentItem
    })
  },
  methods: {
    displayAddItemCommentBtn: function () {
      if (this.editingItemIndex == null) {
        this.displayHoverItemFlag = true
      }
    },
    hideAddItemCommentBtn: function () {
      this.displayHoverItemFlag = false
    },
    selected: function () {
      return (
        this.selectedCommentItem &&
        this.selectedCommentItem.uuid === this.item.uuid
      )
    },
    itemExist () {
      return !this.item._destroy
    },
    isCommentStatus: function () {
      return this.toolBarStatus === 'comment'
    }
  }
}
</script>

<style>
.p-reviewItemBlock__right {
  float: right;
}

.p-reviewButtonBlock {
  margin-top: 20px;
}

.p-reviewItemBlock {
  padding-right: 40px;
}

.p-reviewButtonBlock__selected {
  background-color: rgba(255, 0, 0, 0.15);
}

.p-reviewButtonBlock__reviewBlock {
  right: 4%;
  margin-top: 0.5%;
  z-index: 1;
}
</style>
